import { useEffect, useRef, useState } from "react";
import cn from "classnames";
import { MapComponent, MapErrorBoundary } from "widgets/Map";
import { searchFilterStore } from "entities/SearchFilter";
import { ShipmentTypeChecker } from "entities/shared/utils";
import { useAppSelector } from "shared/lib/redux";
import { GlobeBackdrop } from "./GlobeBackdrop";
import styles from "./MapWrapper.module.scss";

export const MapWrapper: RFC = ({ children }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isGlobe, setIsGlobe] = useState(false);
  const shipment = useAppSelector(searchFilterStore.selectors.shipment);
  const isGlobalTracking = useAppSelector(searchFilterStore.selectors.isGlobalTracking);
  const isShipmentTypeConfirmed = useAppSelector(searchFilterStore.selectors.isShipmentTypeConfirmed);
  const isGlobal = isGlobalTracking && !isShipmentTypeConfirmed;
  const isAir = !isGlobal && ShipmentTypeChecker.isAir(shipment);

  useEffect(() => {
    const root = wrapperRef.current;
    if (!root) return;

    const syncGlobe = () => {
      setIsGlobe(Boolean(root.querySelector("[data-projection='globe']")));
    };

    const observer = new MutationObserver(syncGlobe);
    observer.observe(root, { attributes: true, subtree: true, attributeFilter: ["data-projection"] });
    syncGlobe();

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={cn(styles.mapWrapper, {
        [styles.isAir]: isAir,
        [styles.isGlobal]: isGlobal,
        [styles.isGlobe]: isGlobe,
      })}
    >
      <GlobeBackdrop />
      {/* The map must never be able to take the panel down with it: without a
          boundary out here, a throw inside MapComponent's own effects unmounts
          the whole app and the saved shipments disappear with it. */}
      <div className={styles.mapLayer}>
        <MapErrorBoundary autoReset={false}>
          <MapComponent />
        </MapErrorBoundary>
      </div>
      {children}
    </div>
  );
};
